import { Instance } from 'mobx-state-tree';

import { FilterStore } from '@doltech/ui/lib/filter/Filter/FilterStore';
import {
  ListingFactFilterModel,
  ListingFactFilterStoreInstance,
} from './listing-fact-filter.store';

export const FactModalFilterModel = ListingFactFilterModel.named('FactModalFilterModel');

export interface FactModalFilterModelInstance extends Instance<typeof FactModalFilterModel> {}

export type FactModalFilterStoreInstance = FactModalFilterModelInstance &
  ListingFactFilterStoreInstance;

export interface FactModalFilterStore extends FilterStore {
  modalFilter: FactModalFilterStoreInstance;
}
